export interface AuctioneerAdvertPricingDTO {
  bidIncrement?: number;
  currentPrice?: number;
  startPrice?: number;
  bidCount?: number;
  reserveMet?: boolean;
  ggg?: number;
}
